import { render, staticRenderFns } from "./SettingQuiz.vue?vue&type=template&id=ba0c9e4e&scoped=true"
import script from "./SettingQuiz.vue?vue&type=script&lang=js"
export * from "./SettingQuiz.vue?vue&type=script&lang=js"
import style0 from "./SettingQuiz.vue?vue&type=style&index=0&id=ba0c9e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0c9e4e",
  null
  
)

export default component.exports